import { Component, OnInit } from '@angular/core';
import { AzureOpenaiService } from '../azure-openai.service';

// import { AzureOpenAiService } from '../azure-openai.service';
import { ReferenceComponent } from '../reference/reference.component';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


@Component({
    selector: 'app-prompt',
    imports: [ReferenceComponent],
    templateUrl: './prompt.component.html',
    styleUrl: './prompt.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PromptComponent implements OnInit {
  userPrompt = ''; // User's input
  streamingResponse = ''; // Holds the GPT's response as it streams
  isLoading = false; // Indicates loading state


  constructor(private msalService: MsalService, private router: Router,private azureOpenAiService: AzureOpenaiService) {}

  ngOnInit(): void {
    // Check if the user is authenticated
    // if (!this.msalService.instance.getAllAccounts().length) {
    //   this.msalService.loginRedirect(); // Redirect to login page
    // } else {
    //   this.router.navigate(['/']); // User is authenticated, navigate to profile
    // }
  }


  // async sendPrompt() {
  //   this.streamingResponse = '';
  //   this.isLoading = true;

  //   const reader = await this.azureOpenAiService.getStreamingResponse(this.userPrompt);

  //   if (reader) {
  //     const decoder = new TextDecoder();
  //     let buffer = ''; // Holds incomplete data chunks

  //     const processChunk = async () => {
  //       const { done, value } = await reader.read();

  //       if (done) {
  //         this.isLoading = false; // Stop loading indicator
  //         return;
  //       }

  //       // Decode the chunk and add it to the buffer
  //       buffer += decoder.decode(value, { stream: true });

  //       // Process lines in the buffer
  //       const lines = buffer.split('\n');
  //       buffer = lines.pop()!; // Keep the last incomplete line in the buffer

  //       for (const line of lines) {
  //         if (line.startsWith('data: ')) {
  //           const jsonString = line.substring(6).trim(); // Remove "data: " prefix
  //           try {
  //             const data = JSON.parse(jsonString); // Parse JSON chunk
  //             const content = data.choices[0]?.delta?.content; // Extract "content"
  //             if (content) {
  //               this.streamingResponse += content; // Append to the response
  //             }
  //           } catch (error) {
  //           }
  //         }
  //       }

  //       processChunk(); // Continue processing
  //     };

  //     processChunk();
  //   } else {
  //     this.isLoading = false; // Stop loading if the reader is unavailable
  //   }
  // }
}
